(ns common.schema.entities.workspace.kyc.tenant-kyc-profile
  (:require
   [common.data-types :as data-types]
   [common.schema.schema-utils :as su]
   [common.country :as country]
   [common.schema.entities.kyc.options :as kyc-options]
   [common.schema.option-filters :as option-filters])
  #?(:clj (:import
           (java.util Date))))

(def schema
  (vec
   (concat
    (su/text-simple-field :tenant-kyc-profile/name
                          "Name"
                          {:composite-attributes     [:tenant-kyc-profile/target]
                           :name-attribute           :tenant-kyc-profile/name
                           :calculation-triggers     {:entity.type/company [[:tenant-kyc-profile/_target]]}
                           :editor-type              :editor.type/none
                           :default-field-visibility :in-use})
    (su/single-ref-field :tenant-kyc-profile/target
                         "Tenant company"
                         [:entity.type/company]
                         {:mandatory-config         :mandatory/always
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :default-field-visibility :in-use})

    (su/keyword-field :tenant-kyc-profile/status
                      "Status"
                      kyc-options/status-options
                      {:default-field-visibility :in-use})
    (su/datetime-field :tenant-kyc-profile/next-deadline
                       "Next deadline"
                       {:default-field-visibility :in-use})
    (su/datetime-field :tenant-kyc-profile/approval-date
                       "Approval date"
                       {:default-field-visibility :in-use})
    (su/single-ref-field :tenant-kyc-profile/our-contact
                         "Our contact"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as args}]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use})
    (su/single-ref-field :tenant-kyc-profile/our-kyc-contact
                         "Our KYC contact"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as args}]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use})
    (su/single-ref-field :tenant-kyc-profile/their-contact
                         "Their contact"
                         [:entity.type/person]
                         {:default-field-visibility :in-use})
    (su/single-ref-field :tenant-kyc-profile/their-kyc-contact
                         "Their KYC contact"
                         [:entity.type/person]
                         {:default-field-visibility :in-use})

    (su/keyword-field :tenant-kyc-profile/kyc-country
                      "Jurisdiction"
                      country/options
                      {:default-field-visibility :in-use})

    (su/boolean-field :tenant-kyc-profile/blocked
                      "Blocked"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use})

    (su/datetime-field :kyc-profile/risk-category-changed-on
                       "Risk category changed on"
                       {:editor-type              :editor.type/none
                        :grid-type                :editor.type/none
                        :filter-type              :editor.type/none
                        :default-field-visibility :in-use})

    (su/single-ref-field :kyc-profile/risk-category
                         "KYC category"
                         [:entity.type/kyc-risk-category]
                         {:create-on-fly?           true
                          :authorization            {:access/create :role/user}
                          :default-field-visibility :in-use})

    (su/multi-ref-field :tenant-kyc-profile/kyc-processes
                        "KYC processes"
                        [:entity.type/kyc-process]
                        {:editor-type              :editor.type/none
                         :grid-type                :editor.type/none
                         :filter-type              :filter.type/none
                         :default-field-visibility :in-use})

    (su/option-field :tenant-kyc-profile/ubo-validation "UBO validation" {:default-field-visibility :in-use})

    (su/keyword-field :tenant-kyc-profile/screening-status
                      "Screening status"
                      [{:key :screening-status/auto :label "Auto"}
                       {:key :screening-status/enforced :label "Enforced"}
                       {:key :screening-status/suspended :label "Suspended"}]
                      {:authorization              su/access-user-user
                       :not-clearable?             true
                       :default-field-visibility :in-use
                       :field-in-use-filter        (fn [entity entity-types-lookup
                                                        has-feature-access-fn has-entity-access?]
                                                     (has-feature-access-fn :feature/screening))
                       :hidden-from-configuration? true})

    (su/calculated-field :tenant-kyc-profile/latest-process-status
                         "Latest process status"
                         {:default-field-visibility :in-use
                          :data-type                :data.type/keyword
                          :calculation-triggers     {:entity.type/kyc-process [[:tenant-kyc-profile/_kyc-processes]]}
                          :composite-attrs          [:kyc-process/status :tenant-kyc-profile/kyc-processes]
                          :calc-fn                  (fn [{:keys [logger entity-data entity-lookup tr bigdec->float
                                                                 get-field-schema display-string]}]
                                                      (let [processes (get entity-data :tenant-kyc-profile/kyc-processes)
                                                            latest-process (->> processes
                                                                                (keep entity-lookup)
                                                                                (remove :common/disabled?)
                                                                                (sort-by :common/created-on)
                                                                                (last))]
                                                        (:kyc-process/status latest-process)))})

    (su/calculated-field :tenant-kyc-profile/latest-approved-ubo-count
                         "Number of UBOs"
                         {:data-type                :data.type/integer
                          :default-field-visibility :in-use
                          :composite-attrs          [:tenant-kyc-profile/kyc-processes
                                                     :kyc-process/status
                                                     :kyc-process/answers]
                          :calculation-triggers     {:entity.type/kyc-process [[:tenant-kyc-profile/_kyc-processes]]}
                          :calc-fn                  (fn [{:keys [logger entity-data entity-lookup tr bigdec->float
                                                                 get-field-schema display-string]}]
                                                      (let [processes (get entity-data :tenant-kyc-profile/kyc-processes)
                                                            latest-approved-process
                                                            (->> processes
                                                                 (keep entity-lookup)
                                                                 (remove :common/disabled?)
                                                                 (filter (fn [proc]
                                                                           (contains?
                                                                            #{:kyc-process.status/approved-modified
                                                                              :kyc-process.status/approved}
                                                                            (:kyc-process/status proc))))
                                                                 (sort-by :common/created-on)
                                                                 (last))
                                                            answers (:kyc-process/answers latest-approved-process)
                                                            answers (if (string? answers)
                                                                      (data-types/parse-edn-string answers)
                                                                      answers)
                                                            ubo-attribute (->> answers
                                                                               (keys)
                                                                               (some #{:kyc-tenant/ubo-edn}))
                                                            ubo-data (get answers ubo-attribute)
                                                            ubo-data (if (string? ubo-data)
                                                                       (data-types/parse-edn-string ubo-data)
                                                                       ubo-data)]
                                                        (count ubo-data)))})

    (su/calculated-field :tenant-kyc-profile/datetime-last-invitation
                         "Last invitation sent"
                         {:data-type                :data.type/datetime
                          :default-field-visibility :in-use
                          :composite-attrs          [:tenant-kyc-profile/kyc-processes
                                                     :kyc-process/invited-date]
                          :calculation-triggers     {:entity.type/kyc-process [[:tenant-kyc-profile/_kyc-processes]]}
                          :calc-fn                  (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                                                 bigdec->float get-field-schema display-string]}]
                                                      (let [processes (get entity-data :tenant-kyc-profile/kyc-processes)
                                                            latest-invite-datetime (->> processes
                                                                                        (keep entity-lookup)
                                                                                        (remove :common/disabled?)
                                                                                        (keep :kyc-process/invited-date)
                                                                                        (sort)
                                                                                        (last))]
                                                        latest-invite-datetime))}))))
